import { render, staticRenderFns } from "./CardsRecords.vue?vue&type=template&id=0543f214&scoped=true"
import script from "./CardsRecords.vue?vue&type=script&lang=js"
export * from "./CardsRecords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0543f214",
  null
  
)

export default component.exports